import { AT } from '../../../actions/actionTypes';
import * as Devices from '../../devices';
import { ItemDefault, StateDefault } from './defaults';
import * as CallStatus from '../../../utils/callStatus';
import { findItem, itemByDevice, extendItem, areEqual } from './utils';
import { KeyPL, HistoricalPL, Item, FullInfoPL, State } from './model';
import {
  latestError,
  latestFetch,
  latestSuccess,
  moreError,
  moreFetch,
  moreSuccess,
} from '../../historical/reducer';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const updateStateItem = (state: State, item: Item) => {
  const items = Devices.replaceItemByPK(state.items, item);
  return { ...state, items };
};

export default function (state = StateDefault, action: any) {
  switch (action.type) {
    case AT.DIALOG_DEVICEINFO_KEY_UPDATED: {
      Logger.info(
        [AT.DIALOG_DEVICEINFO_KEY_UPDATED, action],
        LogArea.Redux
      );
      const device: KeyPL = action.payload;
      const deviceKey: string = Devices.getPK(device);
      return { ...state, deviceKey };
    }

    case AT.DIALOG_DEVICEINFO_FETCH: {
      Logger.info([AT.DIALOG_DEVICEINFO_FETCH, action], LogArea.Redux);
      const device: Devices.Device = action.payload;
      const item = findItem(state.items, device) || itemByDevice(device);
      const getInfoCall = CallStatus.fetch(item.getInfoCall);
      const updatedItem: Item = { ...item, getInfoCall };
      return updateStateItem(state, updatedItem);
    }

    case AT.DIALOG_DEVICEINFO_SUCCESS: {
      Logger.info([AT.DIALOG_DEVICEINFO_SUCCESS, action], LogArea.Redux);
      const device: FullInfoPL = action.payload;
      const item = findItem(state.items, device) || itemByDevice(device);
      const getInfoCall = CallStatus.success(item.getInfoCall);
      const updatedItem: Item = {
        ...extendItem(item, device),
        getInfoCall,
      };
      // should data be updated?
      return updateStateItem(state, updatedItem);
    }

    case AT.DIALOG_DEVICEINFO_ERROR: {
      Logger.info([AT.DIALOG_DEVICEINFO_ERROR, action], LogArea.Redux);
      const deviceKey: KeyPL = action.payload;
      const item = findItem(state.items, deviceKey) || ItemDefault(deviceKey);
      const getInfoCall = CallStatus.error(item.getInfoCall, 'cant be loaded');
      const updatedItem: Item = { ...item, getInfoCall };
      return updateStateItem(state, updatedItem);
    }

    case AT.DIALOG_DEVICEINFO_MORELOGS_FETCH: {
      Logger.info(
        [AT.DIALOG_DEVICEINFO_MORELOGS_FETCH, action],
        LogArea.Redux
      );
      const deviceKey: KeyPL = action.payload;
      const item = findItem(state.items, deviceKey) || ItemDefault(deviceKey);
      const historicalLogs = moreFetch(item.historicalLogs);
      const updatedItem = { ...item, historicalLogs };
      return updateStateItem(state, updatedItem);
    }

    case AT.DIALOG_DEVICEINFO_MORELOGS_SUCCESS: {
      Logger.info(
        [AT.DIALOG_DEVICEINFO_MORELOGS_SUCCESS, action],
        LogArea.Redux
      );
      const { device, historical: data }: HistoricalPL = action.payload;
      const item = findItem(state.items, device) || ItemDefault(device);
      const historicalLogs = moreSuccess(item.historicalLogs, data, areEqual);
      const updatedItem: Item = { ...item, historicalLogs };
      return updateStateItem(state, updatedItem);
    }

    case AT.DIALOG_DEVICEINFO_MORELOGS_ERROR: {
      Logger.info(
        [AT.DIALOG_DEVICEINFO_MORELOGS_ERROR, action],
        LogArea.Redux
      );
      const deviceKey: KeyPL = action.payload;
      const item = findItem(state.items, deviceKey) || ItemDefault(deviceKey);
      const historicalLogs = moreError(item.historicalLogs);
      const updatedItem: Item = { ...item, historicalLogs };
      return updateStateItem(state, updatedItem);
    }

    case AT.DIALOG_DEVICEINFO_LATESTLOGS_FETCH: {
      Logger.info(
        [AT.DIALOG_DEVICEINFO_LATESTLOGS_FETCH, action],
        LogArea.Redux
      );
      const deviceKey: KeyPL = action.payload;
      const item = findItem(state.items, deviceKey) || ItemDefault(deviceKey);
      const historicalLogs = latestFetch(item.historicalLogs);
      const updatedItem = { ...item, historicalLogs };
      return updateStateItem(state, updatedItem);
    }

    case AT.DIALOG_DEVICEINFO_LATESTLOGS_SUCCESS: {
      Logger.info(
        [AT.DIALOG_DEVICEINFO_LATESTLOGS_SUCCESS, action],
        LogArea.Redux
      );
      const { device, historical: data }: HistoricalPL = action.payload;
      const item = findItem(state.items, device) || ItemDefault(device);
      const historicalLogs = latestSuccess(item.historicalLogs, data, areEqual);
      const updatedItem: Item = { ...item, historicalLogs };
      return updateStateItem(state, updatedItem);
    }

    case AT.DIALOG_DEVICEINFO_LATESTLOGS_ERROR: {
      Logger.info(
        [AT.DIALOG_DEVICEINFO_LATESTLOGS_ERROR, action],
        LogArea.Redux
      );
      const deviceKey: KeyPL = action.payload;
      const item = findItem(state.items, deviceKey) || ItemDefault(deviceKey);
      const historicalLogs = latestError(item.historicalLogs);
      const updatedItem: Item = { ...item, historicalLogs };
      return updateStateItem(state, updatedItem);
    }

    default: {
      return state;
    }
  }
}
